import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Box } from '@mui/material';
import { useEffect, useState } from 'react';
import socket from './socket';

import Actividad from "./Actividad/containers/Actividad";
import Datos from './Datos/containers/Datos';
import Inventario from "./Inventario/containers/Inventario";
import Stock from "./Stock/containers/Stock";
import Principal from "./Principal/components/PrincipalLayout";
import Ventas from "./Ventas/containers/Ventas";

import NavBar from "./Principal/containers/NavBar";
import Header from "./Principal/containers/Header";
import Login from './Login/containers/Login';
import { getUser, isAuthenticated } from "./auth"

function AppRoutes() {
  const [auth, setAuth] = useState(isAuthenticated());

  useEffect(() => {
    socket.on("connect", () => {
      console.log("✅ Conectado con ID:", socket.id);

      const user = getUser();
      if (user && user.empresa_id) {
        // Se une a la sala correspondiente
        socket.emit("join_empresa", user.empresa_id);
        console.log("🟢 Unido a sala empresa:", user.empresa_id);
      }

      socket.emit("mensaje", "Hola servidor desde React!");
    });
  
    socket.on("mensaje", (data) => {
      console.log("📨 Respuesta del servidor:", data);
    });
  
    return () => {
      socket.off("connect");
      socket.off("mensaje");
    };
  }, []); // <-- este array vacío evita que se ejecute más de una vez
  

  if (!auth) {
    return (
      <Routes>
        <Route 
          path="*" 
          element={
            <Login onLoginSuccess={() => setAuth(true)} />
          } 
        />
      </Routes> 
    );
  }


  return (
    <Box display="flex" height="100vh">
      {/* Barra lateral */}
      <NavBar />
      {/* Contenedor del contenido principal */}
      <Box
        sx={{
          width: "80vw",
          height: "100vh",
          marginLeft: "16%", // ocupa el lugar del navbar
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Header />
        <Box 
          sx={{ 
            marginTop: "6%",
            width: "81.6vw",
            height: "84vh",
            overflow: "auto",
            p: 2,
          }}
        >
          <Routes>
            <Route path="/" element={<Principal />} />
            <Route path="/ventas" element={<Ventas />} />
            <Route path="/actividad" element={<Actividad />} />
            <Route path="/inventario" element={<Inventario />} />
            <Route path="/inventario/stock" element={<Stock />} />
            <Route path="/datos" element={<Datos />} />
          </Routes>
        </Box>
      </Box>
    </Box>
  );
}

export default function App() {
  return (
    <Router>
      <AppRoutes />
    </Router>
  )
}
